import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISimpleResource } from './simple_resource_card_interface';

export class SimpleResourceCardComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-resource-card/src/simple_resource_card/simple_resource_card.html';
  public controller: any = 'SimpleResourceCardController';
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    resource: '<',
    parentCallbackHook: '&?',
    favoriteCallback: '&',
    hideCampus: '@'
  };
}

export class SimpleResourceCardController {
  private resource: ISimpleResource;
  private parentCallbackHook: Function;
  private favoriteCallback: Function;
  private cardCssClass: string;
  private hideCampus: string;
  private isProcessingFavorite: boolean = false;

  constructor(
    private $state: ng.ui.IStateService,
    private log: any,
    private unfavoriteResourceCommand: ICommand,
    private favoriteResourceCommand: ICommand
  ) {
    this.cardCssClass =
      _4.isString(this.cardCssClass) && this.cardCssClass.length > 0 ? this.cardCssClass : 'mobile-card';
    if (!_4.isFunction(this.favoriteCallback)) {
      this.favoriteCallback = () => {};
    }
  }

  goToDetailView(): void {
    if (_4.isFunction(this.parentCallbackHook)) {
      this.parentCallbackHook();
    } else {
      this.$state.go('my.resourcesDetail', {
        id: this.resource.id
      });
    }
  }

  getTruncatedDescription(): string {
    return this.resource.description.length > 80
      ? this.resource.description.substr(0, 80) + '...'
      : this.resource.description;
  }

  toggleFavorite(event: any): void {
    event.preventDefault();
    if (!this.isProcessingFavorite) {
      this.isProcessingFavorite = true;
      this.resource.favorite_id ? this.unFavoriteResource() : this.favoriteResource();
    }
  }

  private unFavoriteResource(): void {
    this.unfavoriteResourceCommand(this.resource)
      .then((res: ISimpleResource) => this.favoriteSuccessCallback(res))
      .catch(() => {
        this.log.user.error('Unable to unfavorite that.');
        this.isProcessingFavorite = false;
      });
  }

  private favoriteResource(): void {
    this.favoriteResourceCommand(this.resource)
      .then((res: ISimpleResource) => this.favoriteSuccessCallback(res))
      .catch(() => {
        this.log.user.error('Unable to favorite that.');
        this.isProcessingFavorite = false;
      });
  }

  private favoriteSuccessCallback(res: ISimpleResource): void {
    _4.assign(this.resource, res);
    this.favoriteCallback();
    this.isProcessingFavorite = false;
  }

  displayCampus() {
    return !!(
      this.hideCampus !== 'true' &&
      !_4.isEmpty(this.resource.location) &&
      !_4.isEmpty(this.resource.location.campus_name)
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-resource-card/src/simple_resource_card/simple_resource_card_controller.ts